import React from 'react';
import PropTypes from 'prop-types';
import SelectSkill from './SelectSkill';

import SkillChip from '../Skill/SkillChip';

const EditSkillList = ({skills = [], onAdd, onRemove}) => (
    <div>
        <SelectSkill onSelect={onAdd} />
        {skills && (
            <div className="cent-card-chips">
                {skills.map((skill) => (<SkillChip key={skill.id} skill={skill} onDelete={() => onRemove(skill.id)} />))}
            </div>
        )}
    </div>
);
EditSkillList.propTypes = {
    skills: PropTypes.array,

    onAdd: PropTypes.func,
    onRemove: PropTypes.func
};

export default EditSkillList;
